// src/components/lead/sections/ChecklistCard.tsx
import type { ExtractedLeadV2 } from "../../../types/lead";
import {
  computeLeadChecklistItems,
  type LeadChecklistItemKey,
  type LeadChecklistItemStatus,
} from "./leadChecklistItems";
import { LeadChecklistRow } from "./LeadChecklistRow";

type Props = {
  e: ExtractedLeadV2;
  /**
   * Slice B1: optional click handler for missing/warning rows. When
   * provided, the row becomes clickable and pulses the amber missing
   * halo to read as actionable. When omitted the card renders as the
   * passive list it always was. The orchestration (flip accordion +
   * scroll + focus) lives in `useChecklistFieldFocus`; this card just
   * forwards the click.
   */
  onItemFocus?: (key: LeadChecklistItemKey) => void;
};

const STATUS_COLOR: Record<LeadChecklistItemStatus, string> = {
  ok: "text-green-600",
  missing: "text-red-600",
  warning: "text-yellow-600",
};

export function ChecklistCard(props: Props) {
  const items = computeLeadChecklistItems(props.e);

  return (
    <div data-app-panel="ChecklistCard" className="mt-6 text-left">
      <h3 className="text-xl sm:text-2xl font-bold mb-2">Checklist</h3>
      <ul className="list-disc pl-6 text-sm sm:text-base space-y-1">
        {items.map((item) => (
          <LeadChecklistRow
            key={item.key}
            item={item}
            onClick={props.onItemFocus}
            statusColorClass={STATUS_COLOR[item.status]}
          />
        ))}
      </ul>
    </div>
  );
}
